import { SingleLineInputFormElementAnswerSchema, SingleLineInputFormElement as SingleLineInputFormElementType } from '@gearbelt/global';
import { z } from 'zod';

import { Checkbox } from '@/components/ui/checkbox';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

import { ConfigLabel } from '../config-label';
import { FormFieldError } from '../form-field-error';

export const SingleLineInputFormElement = ({
  element,
  value,
  onChange,
  onBlur,
  readonly,
  error,
}: {
  element: SingleLineInputFormElementType;
  value?: z.infer<typeof SingleLineInputFormElementAnswerSchema>['value'];
  onChange: (value: z.infer<typeof SingleLineInputFormElementAnswerSchema>['value']) => void;
  onBlur?: () => void;
  readonly?: boolean;
  error?: string;
}) => {
  return (
    <div className="space-y-1">
      <div className="space-y-2">
        <div>
          {element.label && <Label required={element.required}>{element.label}</Label>}
          <Input
            className={cn('disabled:bg-grey-1', !!error && 'border-default-red')}
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            onBlur={onBlur}
            placeholder="Type text..."
            disabled={readonly}
          />
        </div>
      </div>

      <FormFieldError error={error} />
    </div>
  );
};

export function SingleLineInputFormElementMock({ element }: { element: SingleLineInputFormElementType }) {
  return <Input placeholder="Type text..." />;
}

export function SingleLineInputFormElementConfig({
  element,
  onChange,
}: {
  element: SingleLineInputFormElementType;
  onChange?: (updates: Partial<SingleLineInputFormElementType>) => void;
}) {
  return (
    <div className="flex flex-col gap-4">
      <ConfigLabel>
        <span>Label:</span>
        <Input value={element.label} onChange={(e) => onChange?.({ label: e.target.value })} />
      </ConfigLabel>

      <ConfigLabel className="flex-row items-start gap-2">
        <Checkbox checked={element.required} onCheckedChange={(checked) => onChange?.({ required: !!checked })} />
        <span>Required</span>
      </ConfigLabel>
    </div>
  );
}
